import get from 'lodash/get';

import { resolveReclaimPolicyValue } from '../reclaimPolicyField';
import type { DiskVolumeFormValues } from './types';

/** 读取盘容量/存储类/回收策略；未填容量时不回填默认值（自定义规格创建可无容量） */
export function readDiskVolumeFormValues(
  formValues: Record<string, unknown>,
  fields: { diskSize?: string; storageClass?: string; reclaimPolicy?: string } = {},
  options?: { lockReclaimPolicy?: boolean },
): DiskVolumeFormValues {
  const diskSizeField = fields.diskSize ?? 'diskSize';
  const storageClassField = fields.storageClass ?? 'storageClass';
  const reclaimPolicyField = fields.reclaimPolicy ?? 'reclaimPolicy';
  const rawSize = get(formValues, diskSizeField);
  const parsedSize = Number(rawSize);
  const hasSize = rawSize !== undefined && rawSize !== null && rawSize !== '' && Number.isFinite(parsedSize) && parsedSize > 0;

  return {
    ...(hasSize ? { diskSize: parsedSize } : {}),
    storageClass: get(formValues, storageClassField) as string | undefined,
    reclaimPolicy: resolveReclaimPolicyValue(get(formValues, reclaimPolicyField) as string | undefined, options?.lockReclaimPolicy),
  };
}
